import Router from "next/router";
import { useEffect, useRef } from "react";
import useLoader from "@/hooks/useLoader";

type RouteEventMethod = "on" | "off";

const bindRouteEvents = (
  method: RouteEventMethod,
  handlers: {
    onStart: (url: string, options?: { shallow?: boolean }) => void;
    onDone: () => void;
  },
) => {
  Router.events[method]("routeChangeStart", handlers.onStart);
  Router.events[method]("routeChangeComplete", handlers.onDone);
  Router.events[method]("routeChangeError", handlers.onDone);
};

const RouteLoader = () => {
  const { showLoading, hideLoading } = useLoader();
  const didShowLoader = useRef(false);

  useEffect(() => {
    const handlers = {
      onStart: (_url: string, options?: { shallow?: boolean }) => {
        if (options?.shallow) return;
        didShowLoader.current = true;
        showLoading?.();
      },
      onDone: () => {
        if (!didShowLoader.current) return;
        didShowLoader.current = false;
        hideLoading?.();
      },
    };

    bindRouteEvents("on", handlers);
    return () => bindRouteEvents("off", handlers);
  }, [showLoading, hideLoading]);

  return null;
};

export default RouteLoader;
